import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const kebab = (k) => k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
const MEDIA = { mobile: "@media (max-width: 767px)", desktop: "@media (min-width: 768px)" };

export function rulesToCss(rules) {
  return (rules || []).map((r) => {
    const decl = [r.hidden ? "display:none !important" : "", ...Object.entries(r.style || {}).map(([k, v]) => `${kebab(k)}:${v} !important`)].filter(Boolean).join(";");
    if (!decl) return "";
    const sel = r.match === "prefix" ? `[data-testid^="${r.testid}"]` : `[data-testid="${r.testid}"]`;
    const css = `${sel}${r.scope === "children" ? " > *" : r.scope === "descendants" ? " *" : ""}{${decl}}`;
    return MEDIA[r.media] ? `${MEDIA[r.media]}{${css}}` : css;
  }).join("\n");
}

const mediaOk = (m) => !MEDIA[m] || window.matchMedia(MEDIA[m].replace("@media ", "")).matches;

function textNode(el) {
  if (!el.children.length) return null;
  const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.nodeValue.trim() ? 1 : 3) });
  return w.nextNode();
}

function applyTexts(rules) {
  const want = {};
  (rules || []).forEach((r) => { if (r.text && !r.match && !r.scope && mediaOk(r.media)) want[r.testid] = r.text; });
  document.querySelectorAll("[data-orig-text]").forEach((el) => {
    if (!(el.dataset.testid in want)) { const n = textNode(el); if (n) n.nodeValue = el.dataset.origText; else el.textContent = el.dataset.origText; delete el.dataset.origText; }
  });
  Object.entries(want).forEach(([tid, txt]) => {
    document.querySelectorAll(`[data-testid="${tid}"]`).forEach((el) => {
      const n = textNode(el);
      const cur = n ? n.nodeValue : el.textContent;
      if (cur === txt) return;
      if (el.dataset.origText === undefined) el.dataset.origText = cur;
      if (n) n.nodeValue = txt; else el.textContent = txt;
    });
  });
}

export function LayoutOverrides() {
  const [rules, setRules] = useState([]);
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    const load = () => api.get("/layout").then((r) => setRules(r.data.rules || [])).catch(() => {});
    const onPrev = (e) => setPreview(e.detail);
    load();
    window.addEventListener("nolium-layout-refresh", load);
    window.addEventListener("nolium-layout-preview", onPrev);
    return () => { window.removeEventListener("nolium-layout-refresh", load); window.removeEventListener("nolium-layout-preview", onPrev); };
  }, []);
  const active = preview || rules;
  useEffect(() => {
    applyTexts(active);
    let t;
    const obs = new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => applyTexts(active), 60); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => { obs.disconnect(); clearTimeout(t); };
  }, [active]);
  return <style data-testid="layout-overrides-style">{rulesToCss(active)}</style>;
}
